import type { MigrationStrategies } from "./_types/migration-strategies";

export const REFERRAL_MIGRATION_STRATEGIES: MigrationStrategies = {
  1: (oldDoc) => oldDoc,
  2: (_) => null,
  3: (oldDoc) => {
    if (oldDoc.reason) {
      oldDoc.reasons = [oldDoc.reason];
      delete oldDoc.reason;
    }
    return oldDoc;
  },
  4: (oldDoc) => {
    if (oldDoc.facility) {
      oldDoc.freeTextFacility = oldDoc.facility;
      delete oldDoc.facility;
    }
    oldDoc.facilityId = null;
    return oldDoc;
  },
};
